import React, { FC } from 'react';

import { ApolloError } from 'apollo-boost';

import { Extension } from '@atlassian/forge-ui';
import { ForgeUIExtensionPointProvider } from '@atlassian/forge-ui/provider';

import { User } from 'src/components/types';
import { analyticsClient } from 'src/utils/analytics/client';

import { ForgeModuleType } from '../../types';
import { FORGE_PRODUCT } from '../../utils/context';
import { getEnvironment } from '../../utils/environment';

export type RenderForgeExtensions = (
  extensions: ReadonlyArray<Extension>,
  loading: boolean,
  error?: ApolloError
) => any;

type ForgeUIExtensionProviderWrapperProps = {
  currentUser?: User;
  moduleType: ForgeModuleType;
  noAccessRenderFallback?: RenderForgeExtensions;
};

export const ForgeUIExtensionProviderWrapper: FC<
  ForgeUIExtensionProviderWrapperProps
> = ({
  children,
  currentUser,
  moduleType,
  noAccessRenderFallback = () => null,
}) => {
  const isAnonymous = !currentUser?.account_id;

  if (isAnonymous) {
    return noAccessRenderFallback([], false);
  }

  return (
    <ForgeUIExtensionPointProvider
      analyticsWebClient={analyticsClient()}
      environment={getEnvironment()}
      product={FORGE_PRODUCT}
      page={moduleType}
    >
      {children}
    </ForgeUIExtensionPointProvider>
  );
};
